<template>
  <div class="certificate-signatures">
    <div
      v-for="signature in pageSignatures"
      :key="signature.id"
      class="certificate-signature"
      :style="getSignatureStyle(signature)"
    >
      <img
        class="certificate-signature-image"
        :src="signature.image.dataUrl"
        :alt="`Assinatura de ${signature.signer?.name || 'assinante'}`"
      />

      <div class="certificate-signature-caption">
        <strong v-if="signature.signer?.name">
          {{ signature.signer.name }}
        </strong>

        <span v-if="signature.signer?.role">
          {{ signature.signer.role }}
        </span>

        <span v-if="signature.signer?.registry">
          {{ signature.signer.registry }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  signatures: {
    type: Array,
    default: () => [],
  },
  page: {
    type: String,
    default: "front",
  },
});

const pageSignatures = computed(() => {
  return props.signatures.filter((signature) => {
    return (
      signature?.image?.dataUrl &&
      (signature?.placement?.page || "front") === props.page
    );
  });
});

function getSignatureStyle(signature) {
  const placement = signature.placement || {};

  return {
    top: `${Number(placement.topMm || 0)}mm`,
    left: `${Number(placement.leftMm || 0)}mm`,
    width: `${Number(placement.widthMm || 50)}mm`,
    height: `${Number(placement.heightMm || 18)}mm`,
    zIndex: Number(placement.zIndex || 5),
  };
}
</script>

<style scoped>
.certificate-signatures {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.certificate-signature {
  position: absolute;
  display: grid;
  place-items: center;
}

.certificate-signature-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.certificate-signature-caption {
  position: absolute;
  top: calc(100% + 2mm);
  left: 50%;
  width: 125%;
  transform: translateX(-50%);
  text-align: center;
  color: #1f2933;
  font-family: "Arial", sans-serif;
  font-size: 2.7mm;
  font-weight: 700;
  line-height: 1.12;
  white-space: normal;
}

.certificate-signature-caption strong,
.certificate-signature-caption span {
  display: block;
}

.certificate-signature-caption strong {
  font-size: 2.65mm;
  font-weight: 800;
}

.certificate-signature-caption span {
  font-size: 2.45mm;
  font-weight: 700;
}
</style>
